'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _fp = require('lodash/fp');

var _fp2 = _interopRequireDefault(_fp);

var _bdcoreUtilities = require('@bd/bdcore-utilities');

var _FilterCollection = require('../../Filters/FilterCollection');

var _FilterCollection2 = _interopRequireDefault(_FilterCollection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _FilterCollection2.default)('blogposts')('Tag', {
  filter: function filter(blogpost, _ref) {
    var values = _ref.values;

    var tags = _fp2.default.flow(_fp2.default.map(function (tag) {
      return (0, _bdcoreUtilities.Slugify)(tag.trim());
    }), _fp2.default.filter(_fp2.default.identity))(_fp2.default.getOr('', 'tags', blogpost).split(','));

    return _fp2.default.intersection(tags, values.map(function (v) {
      return v.value;
    })).length > 0;
  },
  collectValues: function collectValues(blogposts) {
    var results = _fp2.default.flow(_fp2.default.map(function (post) {
      return _fp2.default.get('tags', post, '').split(',');
    }), _fp2.default.flatten, _fp2.default.uniq, _fp2.default.trim, _fp2.default.map(function (tag) {
      return {
        tag: tag,
        value: (0, _bdcoreUtilities.Slugify)(tag)
      };
    }))(blogposts);

    return results;
  },

  labelRender: function labelRender(_ref2) {
    var tag = _ref2.tag;
    return tag;
  }
});


//////////////////
// WEBPACK FOOTER
// ./~/@bd/bdcore-data/build/Blogposts/filters/Tag.js
// module id = 894
// module chunks = 0